import "jquery";
import _ from "lodash";
import "./stats.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Estadisticas generales";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/
let widget_container = document.createElement("div");
widget_container.classList.add("row");
let widget_row = document.createElement("div");
widget_row.classList.add("col-lg-12", "col-md-12");

widget_container.appendChild(widget_row);

let widget = document.createElement("div");
widget.style.maxWidth = "1400px";
widget.style.margin = "0 auto";
widget.style.lineHeight = "1";

widget_row.appendChild(widget);

let widget_script = document.createElement("script");
widget_script.setAttribute("data-synergy", "");
widget_script.setAttribute("data-type", "fixtures");
widget_script.setAttribute("data-website-id", "14");
widget_script.setAttribute("data-env", "prod");
widget_script.setAttribute("data-use-native-styles", "true");
widget_script.src = "https://embed.web.prod.cloud.atriumsports.com/widget.js";

widget.appendChild(widget_script);

page_template_content.appendChild(widget_container);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/
